import React, { useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Box, TableFooter } from "@mui/material";
import { Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const TableComponent = ({ columns, data, totalCount, widthSet, page, setPage, rowsPerPage, setRowsPerPage }) => {
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('asc');
    const loader = useSelector((state) => state.royaltyDataReducer.loading);
    const skeletonData = [1, 2, 3, 4, 5, 6]
    const handleSort = (property) => (event) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedData = Array.isArray(data) ? [...data].sort((a, b) => {
    if (order === 'asc') {
        return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
        return a[orderBy] > b[orderBy] ? -1 : 1;
    }
}) : [];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <Box>
            <TableContainer className="table-container">
                <Table stickyHeader aria-label="sticky table">
                    <TableHead className="sticky-header">
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell
                                    sx={{ backgroundColor: '#F6F5F5' }}
                                    key={index}
                                    align={column.align}
                                >
                                    <TableSortLabel
                                        // className="suman"
                                        active={orderBy === column.id}
                                        direction={orderBy === column.id ? order : 'asc'}
                                        onClick={handleSort(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {loader ? (
                            <TableRow>
                                <TableCell colSpan={columns.length}>
                                    {skeletonData.map(d => (<Skeleton animation="wave" height={50} />))}
                                </TableCell>
                            </TableRow>
                        // ) : loader == false && data.length == 0 ? (
                        ) : loader === false && Array.isArray(data) && data.length === 0 ? (
                            <TableRow>
                                <TableCell className="text-center p-4 text-bold" colSpan={columns.length}>
                                    NO DATA FOUND
                                </TableCell>
                            </TableRow>
                        ) : (
                            sortedData.map((row, index) => (
                                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                    {columns.map((column, columnIndex) => (
                                        (<TableCell
                                            sx={{
                                                ' &:first-of-type': widthSet ? { width: '50%' } : null
                                            }}
                                            key={column.id}
                                            align={column.align}
                                        >
                                            {column.template ? column.template(row) : row[column.id]}
                                        </TableCell>)
                                    ))}
                                </TableRow>
                            ))

                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                rowsPerPageOptions={[10, 15, 20]}
                component="div"
                // count={(totalCount) ? totalCount : data[0]?.totalCount ? data[0]?.totalCount : data.length}
                count={totalCount ?? (Array.isArray(data) && data.length > 0 ? (data[0]?.totalCount ?? data.length) : 0)}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>

    );
};

export default TableComponent;
